import { render, staticRenderFns } from "./ckEditorMain.vue?vue&type=template&id=2bfbd52a&"
import script from "./ckEditorMain.vue?vue&type=script&lang=js&"
export * from "./ckEditorMain.vue?vue&type=script&lang=js&"
import style0 from "./ckEditorMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports